import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const visualTools = ['Step-by-step visual sequences', 'Movement arrows', 'Position maps', 'Decision trees', 'Correct-vs-incorrect comparisons', 'Progression systems', 'Coaching cue cards', 'Reaction branches', 'Drill setups', 'Session structures'];
export function VisualCoaching() {
  return <section className="py-24 px-4 bg-zinc-950" data-id="element-295" data-mp="1tddqe1fd0llu">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-5xl mx-auto grid md:grid-cols-5 gap-10 md:gap-14 items-start" data-id="element-296" data-mp="1tc2mm1lwzduq">
        <div className="md:col-span-2" data-id="element-297" data-mp="1y6yr418c7toq">
          <p className="font-display font-extrabold uppercase tracking-wide text-sm text-red-500 mb-3" data-id="element-298" data-mp="2d1msb36pg5yj">
            Not another theory PDF
          </p>
          <h2 className="text-3xl md:text-4xl font-black uppercase text-white mb-5" data-id="element-299" data-mp="284wdej6mzgep">
            See it. Understand it. Coach it.
          </h2>
          <p className="text-lg text-zinc-300 mb-4" data-id="element-300" data-mp="3l4e5n298t64j">
            MMA Coach Ready is designed around visual coaching.
          </p>
          <p className="text-lg text-zinc-400" data-id="element-301" data-mp="3p5q13oesslkn">
            You should not have to read ten pages of theory before understanding how to run a drill.
          </p>
          <p className="text-2xl font-display font-black uppercase text-amber-400 mt-6" data-id="element-302" data-mp="2zje7bn843gd">
            Open the page and use it.
          </p>
        </div>

        <div className="md:col-span-3 bg-zinc-900 border border-zinc-800 rounded-2xl p-6 md:p-8" data-id="element-303" data-mp="7wjj3j8c705w">
          <h3 className="text-lg font-extrabold uppercase text-white mb-5" data-id="element-304" data-mp="cpw3ti9wamtd">
            That means the system uses:
          </h3>
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-3" data-id="element-305" data-mp="lpsprc4wh7kq">
            {visualTools.map(tool => <li key={tool} className="flex items-start gap-3" data-id="element-306" data-mp="qom0wxwpsmhq">
                <CheckCircle2 size={18} className="text-amber-400 shrink-0 mt-0.5" aria-hidden="true" data-id="element-307" data-mp="qmrflihj6sd4" />
                <span className="text-zinc-300" data-id="element-308" data-mp="2mpxmh0h1cmkt">{tool}</span>
              </li>)}
          </ul>
        </div>
      </motion.div>
    </section>;
}